<template>
  <section>
    <Loader :loader="formLoader" label="Carregando..." loaderType="progress" />
    <div v-if="!formLoader && user" class="grid grid-cols-12 mt-10">
      <div class="col-span-12 sm:col-span-12 lg:col-span-3 xl:col-span-3">
        <h4 class="mb-5 p-3 text-center sm:text-center lg:text-start">
          {{
            $t("labels.generic", { pt: "Dados da conta", en: "Account data" })
          }}
        </h4>
        <ImageUpload :user="user" />
      </div>
      <div class="col-span-12 sm:col-span-12 lg:col-span-9 xl:col-span-9 mt-12">
        <EditProfile :user="user" />
        <TeacherProfile
          v-if="userFromStorage.role === 'TEACHER'"
          :user="user.teacherProfile"
        />
        <EditPassword />
        <Resources v-if="userFromStorage.role === 'STUDENT'" />
        <AdminTheme v-if="userFromStorage.role === 'ADMINISTRATOR'"/>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { getUserFromStorage } from "@/utils/user-store.util";
import { defineAsyncComponent, defineComponent } from "vue";
import { EditUserService } from "./edit-user.service";

const EditPassword = defineAsyncComponent(
  () => import("./EditPassword/edit-password.vue")
);

const EditProfile = defineAsyncComponent(
  () => import("./EditProfile/edit-profile.vue")
);

const ImageUpload = defineAsyncComponent(
  () => import("./ImageUpload/image-upload.vue")
);

const Resources = defineAsyncComponent(
  () => import("./Resources/resources.vue")
);

const TeacherProfile = defineAsyncComponent(
  () => import("./EditProfile/edit-teacher-profile.vue")
);

const AdminTheme = defineAsyncComponent(() => import("./Theme/index.vue"));

export default defineComponent({
  name: "editUser",
  components: {
    EditPassword,
    EditProfile,
    ImageUpload,
    Resources,
    TeacherProfile,
    AdminTheme,
  },
  computed: {
    service(): EditUserService {
      return new EditUserService();
    },
    userFromStorage(): any {
      return getUserFromStorage();
    },
  },
  data() {
    return {
      user: {} as any,
      formLoader: false as boolean,
    };
  },
  mounted() {
    this.getProfileUser();
  },
  methods: {
    getProfileUser(): void {
      this.service.profile.subscribe({
        next: (response) => {
          var data = response;
          if (response?.birthDate) {
            data.birthDate = new Date(response.birthDate);
          }

          if (response.teacherProfile == null) {
            data.teacherProfile = new Object();
          }
          this.user = data;
          this.formLoader = false;
        },
        error: () => {
          this.formLoader = false;
        },
      });
      this.service.getProfileUser();
    },
  },
});
</script>
